var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"cursor":"pointer","display":"flex","align-items":"center","line-height":"22px"},on:{"click":_vm.contactService}},[_c('img',{staticStyle:{"margin-right":"4px"},attrs:{"src":require("@assets/images/headset-one.svg"),"alt":""}}),_vm._v("\n    联系客服\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }